import {useContext} from 'react';

import {FeatureFlags} from '../api/generated';
import {FeatureFlagsContext} from '../context/FeatureFlagsContext';

export function useFeatureFlags(): FeatureFlags {
  return useContext(FeatureFlagsContext);
}
